import { render, staticRenderFns } from "./mass.vue?vue&type=template&id=659536a2&scoped=true&"
import script from "./mass.vue?vue&type=script&lang=js&"
export * from "./mass.vue?vue&type=script&lang=js&"
import style0 from "./mass.vue?vue&type=style&index=0&id=659536a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659536a2",
  null
  
)

export default component.exports